import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';
import { map, take } from 'rxjs';
import { selectIsAdmin } from '../../../store/selectors/account.selectors';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private store: Store<AppState>, private router: Router) {}

  canActivate() {
    return this.store.select(selectIsAdmin).pipe(
      take(1),
      map((isAdmin) => {
        console.log('here');
        if (isAdmin) {
          return true;
        }
        return this.router.parseUrl('/');
      }),
    );
  }
}
